import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const MainFooter = () => {
  return (
    <div className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">VA Sprouts</h3>
            <p className="text-gray-400 mb-4">
              Connecting skilled virtual assistants with businesses looking for quality talent.
            </p>
            <div className="flex space-x-4">
              <a href="https://twitter.com/vasprouts" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Icon name="Twitter" size={20} />
              </a>
              <a href="https://linkedin.com/company/vasprouts" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Icon name="Linkedin" size={20} />
              </a>
              <a href="https://facebook.com/vasprouts" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Icon name="Facebook" size={20} />
              </a>
              <a href="https://instagram.com/vasprouts" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <Icon name="Instagram" size={20} />
              </a>
            </div>
          </div>

          {/* For VAs */}
          <div>
            <h3 className="text-lg font-semibold mb-4">For Virtual Assistants</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/job-search" className="text-gray-400 hover:text-white transition-colors">
                  Find Jobs
                </Link>
              </li>
              <li>
                <Link to="/skills-directory" className="text-gray-400 hover:text-white transition-colors">
                  Skills Directory
                </Link>
              </li>
              <li>
                <Link to="/up-skills" className="text-gray-400 hover:text-white transition-colors">
                  Skill Assessment
                </Link>
              </li>
              <li>
                <Link to="/login-register?tab=register&role=va" className="text-gray-400 hover:text-white transition-colors">
                  Create VA Profile
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-400 hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
            </ul>
          </div>

          {/* For Employers */}
          <div>
            <h3 className="text-lg font-semibold mb-4">For Employers</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/browse-candidates" className="text-gray-400 hover:text-white transition-colors">
                  Browse VAs
                </Link>
              </li>
              <li>
                <Link to="/job-posting" className="text-gray-400 hover:text-white transition-colors">
                  Post a Job
                </Link>
              </li>
              <li>
                <Link to="/login-register?tab=register&role=employer" className="text-gray-400 hover:text-white transition-colors">
                  Create Employer Account
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-400 hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/enterprise-features" className="text-gray-400 hover:text-white transition-colors">
                  Enterprise Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/help-support" className="text-gray-400 hover:text-white transition-colors">
                  Help & Support
                </Link>
              </li>
              <li>
                <a href="/blog" className="text-gray-400 hover:text-white transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <Link to="/community-guidelines" className="text-gray-400 hover:text-white transition-colors">
                  Community Guidelines
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="text-gray-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainFooter;
